import React from 'react';
import AutoComplete from 'material-ui/AutoComplete';

import Util from '../../Util';

class AddressField extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      address: '',
      addresses: [],
      modalOpen: false
    };

    this.setAddress = this.setAddress.bind(this);
    this.onNewRequest = this.onNewRequest.bind(this);

    this.handleAutoCompleteInput = this.handleAutoCompleteInput.bind(this);
  }

  componentDidMount() {
    // If we want the field to be rendered and then opened 
    this.setState({
      modalOpen: this.props.isOpen
    })
  }

  setAddress(address) {
    this.props.fieldChanged('address', address);
  }

  onNewRequest(selectedData, searchedText, selectedDataIndex) {
    this.setAddress(selectedData);
  }

  handleAutoCompleteInput(value) {
    const params = [];
    params.push('searchQuery=' + value);

    if (!value) return;

    return Util.backendGet('google-maps/autocomplete', localStorage.getItem('token'), params).then((result) => {
      this.setState({
        addresses: result.predictions || []
      });
    }).catch((err) => {
      console.log(err);
    });
  }
 
  render() {
    return (
      <AutoComplete
        name="location"
        floatingLabelText="Type the address"
        dataSource={this.state.addresses.map(object => object.prediction)}
        onUpdateInput={this.handleAutoCompleteInput}
        onNewRequest={this.onNewRequest}
        animated={true}
        filter={() => {return true}}
        style={this.props.styles.inputStyle}
        fullWidth={true}
        open={this.state.modalOpen}
        inputStyle={this.props.styles.inputStyle}
        hintStyle={this.props.styles.hintStyle}
      />
    );
  }
}
 
export default AddressField;



// WEBPACK FOOTER //
// ./src/app/components/elements/AddressField.js